export function isTryOnAvailable(item) {
  const tryOn = item?.try_on || item?.tryOn || item || null;
  const assets = tryOn?.assets || {};

  const status = tryOn?.status || null;

  const frontAsset =
    assets.front ||
    tryOn?.frontAsset ||
    tryOn?.asset_generation?.front?.asset_url ||
    tryOn?.assetGeneration?.front?.asset_url ||
    tryOn?.assetGeneration?.front?.assetUrl ||
    null;

  const frontGenerated =
    tryOn?.asset_generation?.front?.status === "generated" ||
    tryOn?.assetGeneration?.front?.status === "generated";

  if (!item?.meshUrl) return false;

  // local dev and production both pass this:
  // local: /tryon-assets/products/19/front.png
  // prod: https://pub-...r2.dev/tryon-assets/products/19/front.png
  if (!frontAsset && !frontGenerated) return false;

  if (["available", "front_only", "generated", "ready"].includes(status)) {
    return true;
  }

  return Boolean(frontAsset || frontGenerated);
}